import { useBoardUrl } from '../use-board-url/index.tsx';
import { getBoardSettingsUrl } from '../../common/url-utils/index.tsx';

export function useBoardSettingsUrl(): string {
	return getBoardSettingsUrl(useBoardUrl());
}
